var render = function () {
  var _vm$list;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ("sale-markers-list sale-markers-list_" + (_vm.type))
  }, [(_vm$list = _vm.list) !== null && _vm$list !== void 0 && _vm$list.length ? _c('LazyHydrate', {
    attrs: {
      "on-interaction": "mouseover"
    }
  }, [_c('div', {
    directives: [{
      name: "dragscroll",
      rawName: "v-dragscroll",
      value: true,
      expression: "true"
    }],
    staticClass: "sale-markers-list__list"
  }, _vm._l(_vm.list, function (sale) {
    return _c('div', {
      key: sale.id,
      staticClass: "sale-markers-list__wrap"
    }, [_c('SaleMarker', {
      attrs: {
        "sale": sale,
        "type": _vm.type
      }
    })], 1);
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sale-markers-list__list-overlay"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }